import { Fragment, PureComponent, ReactNode } from 'react';
import { PtDirLastUpdatedAt } from '../../constants';
import { getAllPatients, getItemFromMisc, MISC_KEYS } from '../../store/idbHandler';
import { RunningDiagnosisStatusType, RunningDiagnosisStrip } from './RunningDiagnosisStrip';
import { getMyDbId } from '../../api/mactiveid';

type P = {
    onSuccess: (obj: { [k: string]: string }) => void;
    onFailure: (obj: { [k: string]: string }) => void;
};

type S = {
    status: RunningDiagnosisStatusType;
    counts?: { [k: string]: number | string | undefined };
};

class PtCountCheck extends PureComponent<P, S> {
    state: S = {
        status: 'running',
    };

    componentDidMount = async (): Promise<void> => {
        const localPtDir = await getAllPatients();
        const ptWithLocalId = localPtDir?.filter((pt) => !pt.id) || [];
        const lastUpdated = await getItemFromMisc<PtDirLastUpdatedAt>(
            getMyDbId() || '',
            MISC_KEYS.ptDirLastUpdated,
        );

        this.setState({
            status: 'success',
            counts: {
                'Last updated patient directory': lastUpdated.isoString,
                'Unsynced patients': ptWithLocalId.length,
            },
        });

        const { onSuccess } = this.props;
        onSuccess({
            status: 'success',
            name: 'Unsync data',
            unsyncPtcount: ptWithLocalId.length.toString(),
        });
    };

    render(): ReactNode {
        const { status, counts } = this.state;
        return (
            <Fragment>
                <RunningDiagnosisStrip name="Patient directory" status={status} />
                <div className="py-16">
                    {counts &&
                        Object.entries(counts).map(([k, v]) => (
                            <p>
                                {k}: {v}
                            </p>
                        ))}
                    {this.props.children}
                </div>
            </Fragment>
        );
    }
}

export default PtCountCheck;
